module.exports = __webpack_public_path__ + "static/img/help_02class_02.2167d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_02.png
// module id = 683
// module chunks = 140